import React, { Fragment } from 'react';
import { object } from 'prop-types';

import { TabsS } from './styled-components';
import { Title } from '../styled-components';
import { ListUsers } from './list-users';
import { InviteUserForm } from './invite-user-form';
import { USER_ROLES } from '../../api/constants';

const ManageUsersModalComp = ({ authorizedUser }) => {
  const { TabPane } = TabsS;

  return (
    <Fragment>
      <Title>Users</Title>
      {(authorizedUser.role === USER_ROLES.SUPER_ADMIN
        || authorizedUser.role === USER_ROLES.ADMIN) && (
        <Fragment>
          <InviteUserForm authorizedUser={authorizedUser} />
        </Fragment>
      )}
      <TabsS defaultActiveKey="1" animated={false}>
        <TabPane tab="Active" key="1">
          <ListUsers />
        </TabPane>
        <TabPane tab="Archived" key="2">
          <ListUsers isDeleted />
        </TabPane>
      </TabsS>
    </Fragment>
  );
};

ManageUsersModalComp.propTypes = {
  authorizedUser: object.isRequired,
};

export default ManageUsersModalComp;



// WEBPACK FOOTER //
// ./src/modals/manage-users-modal/manage-users-modal-comp.js